import { Component, OnInit, Input } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { Router } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { HttpCacheService } from 'src/modules/base/shared/services/http-cache.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';

@Component({
    selector: 'hra',
    templateUrl: './hra.component.html',
    styleUrls: ['./hra.component.scss'],
    standalone: false
})
export class HraComponent implements OnInit {

  @Input() data: any;
  config: any = {};
  data_: any;
  showSkeletonLoader = true;
  height: string;
  patientDetails: any;
  constructor(
    private baseService: BaseService,
    public dashBoardService: DashboardService,
    public utilService: UtilService,
    private loader: LoaderService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public printService: PrintService,
    public alert: AlertsService,
    public cacheService:HttpCacheService,
    private storageService: StorageService, 
  ) { }

  ngOnInit(): void {
    this.build();
    this.getInfo();
    if (this.utilService.isMobile()) {
      this.height = '160px'
     } else {
      this.height = '180px'
  
     }
    

  }

  getInfo() {
    try {
      this.patientDetails = JSON.parse(localStorage.getItem('patientDetails'));
      //let args= "cug_code:"+this.storageService.getBgDetails().cug_code+",status:active,category_type:hra_assessment,gender:"+this.patientDetails.gender_id;
      let args = "";
      this.baseService.get('GET_CATEGORY_BASED_ON_GENDER', args, 'assessment_category', 'assessment', '').subscribe(data => {
        if (data != undefined && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
          this.data_ = data.resource[0];
          let obj = {
            filter: "assessment_id:" + this.data_.template_assessment_id + ",category_id:" + this.data_.id + ",user_id:" + this.authenticationService.getCurrentUser().user_id+ ",status:Final" 
          }
          this.baseService.getData(obj, '', "assessment_progress", "assessment", "GET_PAGE").subscribe(innerData => {
            if (innerData != undefined && innerData.resource != undefined && innerData.resource.length != undefined && innerData.resource.length > 0) {
              this.config['innerData'] = innerData.resource[0];
            }
          })
        }
        else {
          this.data_ = '';

        }
      })
    } catch (error) {

    }

  }

  handleLinkClick() {
    if(this.data && this.data_.id){
      this.router.navigate([this.config.data.link+"/"+this.data_.id+"/description"]);
    }
    else
    {
      this.router.navigate([this.config.data.link]);
    }
  }
  build() {
    // this.loader.showSpinner();
    let id = this.data.slider_id || this.data.widget_id;
    //if(this.cacheService.checkWidget( 'hra', id)) {
    this.baseService.getById(id, 'widget_config', 'account-management').subscribe(res => {
      this.config.data = res;
     // this.cacheService.setWidgetStorage('hra', res);
      if (res && res.document_id) {
        this.config.data.imgUrl = this.utilService.getImageUrl(res.document_id);
      }
      // this.loader.hideSpinner();
      this.showSkeletonLoader = false;
    });
 // }
  // else {
  //   this.cacheService.getWidget().subscribe(value => {
  //    const List = value.filter(ele => ele['hra']);
  //    const configData = List.filter(ele => ele['hra'].id === id)
  //    this.config.data = configData && configData.length > 0 ? configData[0]['hra'] : '';
  //     this.showSkeletonLoader = false;

  //   })
  // }
  }

  downloadReport() {
    if (this.config != undefined && this.config['innerData'] != undefined && this.config['innerData']!= "") {
      this.assessmentReport(this.config['innerData']);
    }
    else {
      this.alert.info("Complete HRA for report generation.");
    }
  }

  assessmentReport(res) {
    this.loader.showSpinner()
    let payload = {};
    payload["args"] = `id:${res.id},user_id:${this.authenticationService.getCurrentUser().user_id},assessment_id:${res.assessment_id},category_id:${res.category_id},reportTemplateId:AssessmentscorereportPrint,userPrint:Y,contentType:pdf`,
      payload["filterPrintInfo"] = false,
      payload["resource"] = "assessment_progress",
      payload["template"] = "AssessmentscorereportPrint",
      payload["responseType"] = 'blob',
      payload["contentType"] = 'pdf',
      payload['key'] = res.id;
      payload["tag_data"] = [],
      payload["application"] = "assessment"
    this.baseService.handleFile(payload, async (fileData) => {
      if (fileData) {
        this.loader.hideSpinner();
        this.printService.handleFileReponse(payload, "download", fileData, (result) => {
          if (result) {
            //this.loader.hideSpinner()
            this.alert.success("Request Successful");
          } else {
            //this.loader.hideSpinner()
            this.alert.error("Error in getting data");
          }
        });
      }
      else{
        this.loader.hideSpinner();
      }
    })
    
  }

}
